import { RefundState } from '../../types';

export const getSelectedReason = (state: RefundState) => state.reason;
